import axios from 'axios';
import { API_BASE_URL, endpoints } from './config';

const apiClient = axios.create({
    baseURL: `${API_BASE_URL}/api`,
    params: { lang: 'en' }, // Default language
});

export const fetchFAQs = async ({ page, lang }) => {
    try {
        const response = await apiClient.get(endpoints.faqs.list, {
            params: {
                page: page || 1,
                lang,
                ordering: '-created_at',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching FAQs:', error);
        throw new Error(error.response?.data?.detail || 'Failed to fetch FAQs');
    }
};

export const fetchFAQDetails = async (id, lang) => {
    try {
        const response = await apiClient.get(endpoints.faqs.detail(id), {
            params: { lang },
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching FAQ details:', error);
        throw new Error(error.response?.data?.detail || 'Failed to fetch FAQ details');
    }
};